<template>
  <Disclosure as="div" class="w-full" v-slot="{ open }">
    <DisclosurePanel as="div">
      <footer class="bg-[#FFF]" aria-labelledby="footer-heading">
        <h2 id="footer-heading" class="sr-only">Footer</h2>
        <div class="mx-auto px-6 py-16 lg:px-8 relative">
          <DisclosureButton>
            <XMarkIcon
              class="mx-auto h-6 w-auto text-gray-400 absolute top-5 right-5"
              aria-hidden="true"
            ></XMarkIcon>
          </DisclosureButton>
          <div class="xl:grid xl:grid-cols-2 xl:gap-12">
            <div class="mt-0 grid grid-cols-2 gap-8 xl:col-span-2">
              <div class="md:grid md:grid-cols-2 md:gap-8">
                <div class="text-left flex flex-col mx-auto">
                  <h3
                    class="text-xl text-left font-bold leading-6 text-gray-900"
                  >
                    Our Values
                  </h3>
                  <ul role="list" class="mt-6 space-y-4">
                    <li
                      v-for="item in navigationExpand.values"
                      :key="item.name"
                    >
                      <a
                        :href="item.href"
                        class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                        >{{ item.name }}</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="mt-10 md:mt-0 text-left flex flex-col mx-auto">
                  <h3 class="text-xl font-bold leading-6 text-gray-900">
                    Resources
                  </h3>
                  <ul role="list" class="mt-6 space-y-4">
                    <li
                      v-for="item in navigationExpand.resources"
                      :key="item.name"
                    >
                      <a
                        :href="item.href"
                        class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                        >{{ item.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="md:grid md:grid-cols-2 md:gap-8">
                <div class="text-left flex flex-col mx-auto">
                  <h3 class="text-xl font-bold leading-6 text-gray-900">
                    Technology
                  </h3>
                  <ul role="list" class="mt-6 space-y-4">
                    <li
                      v-for="item in navigationExpand.technology"
                      :key="item.name"
                    >
                      <a
                        :href="item.href"
                        class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                        >{{ item.name }}</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="mt-10 md:mt-0 text-left flex flex-col mx-auto">
                  <h3 class="text-xl font-bold leading-6 text-gray-900">
                    Support
                  </h3>
                  <ul role="list" class="mt-6 space-y-4">
                    <li v-for="item in navigationExpand.legal" :key="item.name">
                      <a
                        :href="item.href"
                        class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                        >{{ item.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex items-center justify-between sm:items-right sm:justify-end pt-5 -mb-5"
          >
            <div class="flex sm:hidden gap-x-6 pt-5">
              <a
                v-for="item in navigation"
                :key="item.name"
                :href="item.href"
                target="_blank"
                class="text-gray-400 hover:text-gray-500"
              >
                <span class="sr-only">{{ item.name }}</span>
                <IconManager
                  :name="item.name"
                  class="h-6 w-6"
                  aria-hidden="true"
                />
              </a>
            </div>

            <img class="h-12 w-auto" src="../../assets/logo.png" alt="" />
          </div>
        </div>
      </footer>
    </DisclosurePanel>
    <footer class="bg-[#FFF]">
      <div
        class="mx-auto px-6 lg:px-8 py-3 md:flex md:items-center md:justify-between"
      >
        <div class="flex justify-between sm:space-x-6 md:order-2">
          <a
            v-for="item in navigation"
            :key="item.name"
            :href="item.href"
            target="_blank"
            class="hidden sm:block text-gray-400 hover:text-gray-500"
          >
            <span class="sr-only">{{ item.name }}</span>
            <IconManager :name="item.name" class="h-6 w-6" aria-hidden="true" />
          </a>
          <div class="block sm:hidden items-start justify-start">
            <a href="/"
              ><img class="h-6 w-auto" src="../../assets/logo.png" alt=""
            /></a>
          </div>
          <div class="flex gap-x-4 text-xs items-center font-bold pl-6">
            <a href="/contact">Contact Us</a>
            <DisclosureButton>
              <span class="underline">Support & Resources</span>
            </DisclosureButton>
            <DisclosureButton>
              <ChevronUpIcon
                :class="open ? 'rotate-180 transform' : ''"
                class="h-5 w-5 text-gray-900"
              ></ChevronUpIcon>
            </DisclosureButton>
          </div>
        </div>
        <div
          class="hidden sm:flex mt-4 md:order-1 md:mt-0 items-center gap-x-6"
        >
          <a href="/"
            ><img class="h-6 w-auto" src="../../assets/logo.png" alt=""
          /></a>
          <p class="text-center text-xs leading-5 text-[#6D6D6D]">
            &copy; 2024 Ductclean UK Limited ·
            <a href="/privacy-policy">Privacy</a>
          </p>
        </div>
      </div>
    </footer>
  </Disclosure>
</template>

<script>
import IconManager from "./IconManager.vue";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronUpIcon, XMarkIcon } from "@heroicons/vue/20/solid";
export default {
  components: {
    IconManager,
    ChevronUpIcon,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    XMarkIcon,
  },
  data() {
    return {
      navigation: [
        {
          name: "Facebook",
          href: "https://www.facebook.com/dcukfm/?locale=en_GB",
        },
        {
          name: "Linkedin",
          href: "https://uk.linkedin.com/company/ductclean-uk-ltd",
        },
        {
          name: "Twitter",
          href: "https://twitter.com/dcukfm",
        },
        {
          name: "Instagram",
          href: "https://www.instagram.com/dcukfm/",
        },
        {
          name: "Youtube",
          href: "https://www.youtube.com/channel/UCmTl0BXff7mGT1zLz2fNeHA/videos",
        },
      ],
      navigationExpand: {
        values: [
          { name: "About DCUK", href: "/our-company" },
          { name: "Sustainability", href: "/sustainability" },
          { name: "Equal Opportunities", href: "/equal-opportunities" },
        ],
        resources: [
          { name: "Privacy Policy", href: "/privacy-policy" },
          // { name: "Legislation and Regulations", href: "/legislation" },
          { name: "Health and Safety", href: "/health-safety" },
          { name: "Policies", href: "/policies" },
        ],
        technology: [
          { name: "L3XI", href: "/technology#lexi" },
          { name: "SpacePlus", href: "/technology#spaceplus" },
          { name: "IMOS", href: "/technology#imos" },
        ],
        legal: [
          { name: "Contact Us", href: "/contact" },
          { name: "Careers", href: "/careers" },
          { name: "Brand Guidelines", href: "/brand-guidelines" },
        ],
      },
    };
  },
};
</script>
